import { indexOf, isUndefined } from "lodash";
import constants from '../components/react-flow-pedigree/constants';
import Cookie from 'js-cookie'
import moment from 'moment';
import {
  skipLogicCheck
} from '../components/react-flow-pedigree/skip_logic_utils'

const geneMap = {
  'p': "Pathogenic",
  'n': "Negative",
  'lp': "Likely Pathogenic",
  'vus': "VUS",
  'ln': "Likely Benign",
  'unsure': "Unsure"
}

const answersInclude = ['y', 'p']
const answersExclude = ['n', '']
const skipLogicMap = {
  'p' : 'Pos.',
  'n' : 'Neg'
}

const createHeader = (width, height)=>{
  const svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg')
  svg.setAttributeNS(null, "width", width)
  svg.setAttributeNS(null, "height", height)
  svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
  return svg
}

const createSvgFamilyHistory = (fullName, diseases, genes, profiles, pedigreeNotes) =>{
  const header = createHeader(800, 850)
  const [familyHistory, pdfHeight] = createFamily(fullName, diseases, genes, profiles, pedigreeNotes, header)
  let svgString = new XMLSerializer().serializeToString(familyHistory)
  return [svgString, pdfHeight]
}

const createSVGPdf = (pedigree, width, height, negativeOffset, heightOffset) =>{
  let pedigreeCopy = CreateSvgString(pedigree, width, height, negativeOffset, heightOffset)
  let pedigireeString = new XMLSerializer().serializeToString(pedigreeCopy)
  return pedigireeString
}

const CreateSvgString =  (pedigree, width, height, negativeOffset, heightOffset) => {
  const max_single_page_width = 1200
  const max_single_page_height = 750
  const centerPedigree = (width - max_single_page_width )/2
  let centerWidth = (negativeOffset * -1)
  const centerHeight = (height - max_single_page_height)/2
  let centerHeightOffset = (heightOffset * -1)

  if (width < max_single_page_width) {
    let xCenteringOffset = (max_single_page_width - width) / 2
    centerWidth = centerWidth + xCenteringOffset
  }

  if (height < max_single_page_height) {
    let yCenteringOffset = (max_single_page_height - height) / 2
    centerHeightOffset = centerHeightOffset + yCenteringOffset
  }

  const svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg')
  svg.setAttributeNS(null, "width", width)
  svg.setAttributeNS(null, "height", height)
  svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");

  let gTags = pedigree.getElementsByClassName('react-flow__edge')
  let nodes = pedigree.getElementsByClassName('react-flow__node react-flow__node-person')
  let ancestry = pedigree.getElementsByClassName('react-flow__node-ancestry')


  // Create ancestry nodes for pedigree
  for (var index = 0; index < ancestry.length; index++) {
    let transform = getTransformation(ancestry[index], centerWidth, centerHeightOffset)
    let svgAncestry = createSVGAncestry(ancestry[index], transform['x'], transform['y'])
    svg.append(svgAncestry)
  }

  for(var i = 0; i < gTags.length; i++) {
      //adds all the pedigree lines to the svg string
      let lineSVG = getLineSVG(gTags[i], centerWidth, centerHeightOffset)
      if(!isUndefined(lineSVG)) svg.appendChild(lineSVG)
  }

  for(let i = 0; i < nodes.length; i++){
    let transform = getTransformation(nodes[i], centerWidth, centerHeightOffset)
    let svgNode = getPersonSVG(nodes[i], transform['x'], transform['y'])

    //sort the node so that all lines are drawn over the individuals
    let sortedNodes = sortingNodes(svgNode, transform['x'], transform['y'])
    if(!isUndefined(sortedNodes)) svg.appendChild(sortedNodes)
  }

  // let pedigireeString = new XMLSerializer().serializeToString(svg)
  return svg
}

const getPersonSVG = (node, x, y) =>{
  let parentNode = createParentGTag(x, y)
  //loop through all nodes adding shapes, lines and subtext
  node.childNodes.forEach(node =>{

    //This will add shape/person to the parent node
    if(node.nodeName == 'svg') createPeopleSVG(parentNode, node)

    //add all adopted frames and deceased lines to individuals
    if(node.firstChild !==null && node.firstChild.nodeName =='svg') addAdpotedDeceasedLines(parentNode, node)

    //add all subtext to individuals
    if(node.id.startsWith("domSubtext") || node.className == 'react-flow__node react-flow__node-birth_assignment') createSubtextNode(parentNode,node.cloneNode(true))
  })

  return parentNode
}

const createPeopleSVG = (parentNode, node) =>{
  node.childNodes.forEach(child=>{
    let childClone = child.cloneNode(true)
    childClone.setAttribute("style", "stroke: rgb(0,0,0); fill:white")
    parentNode.append(childClone)
  })
}

const createSubtextNode = (parentNode , subtextNode) =>{
  if (subtextNode.firstChild.id == 'domViewRecord'){
    subtextNode.removeChild(subtextNode.firstChild)
  }
  let subtextNodeSVG = createSubtextSVG(subtextNode)
  parentNode.appendChild(subtextNodeSVG)
}


const addAdpotedDeceasedLines = (parentNode, node)=>{
    //if this is hit means there is adopted frames that need to be transformed/updated
    node.firstChild.childNodes.forEach(line=>{
      if(hasChildNodes(line)){
          let rightAdoptedFrame = node.style['right'].replace('px', '').trim()
          let leftAdoptedFrame = node.style['left'].replace('px', '').trim()
          let yAdoptedFrame = node.style['top'].replace('px', '').trim()
          let x = rightAdoptedFrame ? 26 : leftAdoptedFrame;
          let adoptedNode = line.cloneNode(true)
          adoptedNode.setAttribute('transform', `matrix(1, 0, 0, 1, ${x}, ${yAdoptedFrame})`)

          if(adoptedNode.childNodes.length > 0){
            adoptedNode.childNodes.forEach(adoptedLine=>{
              adoptedLine.setAttribute("style", "fill:rgb(189, 189, 189); stroke:rgb(0, 0, 0)")
            })
          }
        parentNode.appendChild(adoptedNode)
      }
    })

    if(node.firstChild.firstChild !==null && node.firstChild.firstChild.nodeName =='line'){
      let deceasedLine = node.firstChild.firstChild.cloneNode(true)
      let deceasedNode = createDeceasedNode(deceasedLine)
      parentNode.appendChild(deceasedNode)
    }else if(node.firstChild.firstChild !==null && node.firstChild.firstChild.nodeName =='polygon'){
      let probandArrow = createProbandArrowTag()
      let probandArrowNode = node.firstChild.cloneNode(true)
      probandArrowNode.childNodes.forEach(arrow=>{
        arrow.setAttribute("style", "fill:rgb(0, 0, 0); stroke:rgb(0, 0, 0)")
        probandArrow.append(probandArrowNode)
      })
      parentNode.appendChild(probandArrow)
  }
}

const sortingNodes = (parentNodeClone, x, y) =>{
  let finalTag = createParentGTag(x, y)
  let sortedNodes = Array.from(parentNodeClone.childNodes)// Array.prototype.slice.call(parentNodeClone);
  let theNodes = sortedNodes.sort((a,b)=>{
   if(typeof InstallTrigger !== 'undefined'){
    if(a.nodeName === 'line' && b.nodeName !== 'line') return 1
   }else{
    if(a.nodeName !== 'line' && b.nodeName == 'line') return -1
   }

  })
  theNodes.forEach(node=> finalTag.appendChild(node))
  return finalTag
}


const createDeceasedNode = (deceasedLine) =>{

  deceasedLine.setAttribute("style", "fill:rgb(0, 0, 0); stroke:rgb(0, 0, 0)")
  deceasedLine.setAttribute("x1", "-5" )
  deceasedLine.setAttribute("x2", "46")
  deceasedLine.setAttribute("y1", "46")
  deceasedLine.setAttribute("y2", "-5")

  return deceasedLine

}
const hasChildNodes = (node) =>{
  return node.childNodes.length > 0
}

const createSVGAncestry = (ancestry, x, y) =>{

    let ancestryNode = createParentLineTag()
    ancestry.childNodes.forEach(word=>{
    let text = word.innerHTML
      if(text){
          var svgText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          svgText.setAttribute('font-family', 'Helvetica, Arial, sans-serif')
          svgText.setAttribute('x', `${x}`)
          svgText.setAttribute('y', `${y}`)

          var tSpanTextNode = document.createTextNode(text);
          svgText.appendChild(tSpanTextNode);
          ancestryNode.appendChild(svgText)
          y = parseFloat(y) + 12
      }
    })

  return ancestryNode;
}

const replaceHTMLCharacters = (text) => {
  text = text.replaceAll("&lt;", "<");
  text = text.replaceAll("&gt;", ">");
  text = text.replaceAll("&amp;", "&");
  text = text.replaceAll("&quot;", "\"");
  text = text.replaceAll("&apos;", "\'");

  return text;
}

const createSubtextSVG = (subtextNode) =>{
  let subtextNodeSVG = createParentLineTag();
  let textValue = "";
  let textValues = [];
  const regexp = /[<]br[>]/g;

  if (subtextNode.firstChild && subtextNode.firstChild.innerText) {
    // textValue = subtextNode.firstChild.innerText;
    textValue = subtextNode.firstChild.innerHTML;
  } else if (subtextNode.innerText) {
    // textValue = subtextNode.innerText;
    textValue = subtextNode.innerHTML;
  }

  if (textValue) {
    textValue = replaceHTMLCharacters(textValue);
    const arry = [...textValue.matchAll(regexp)];
    if (arry.length > 0) {
      textValues = textValue.split("<br>");
    } else {
      textValues = textValue.split("\n");
    }
  }

  let y = 58
  let x = 20

  if(subtextNode.className == 'react-flow__node react-flow__node-birth_assignment'){
    y = -8
    x = -4
  }

    // max number of chars per line for subtext
  var MAXIMUM_CHARS_PER_LINE = 19;
  textValues.forEach(text =>{
    text = text.trim()
    if(text.length <= MAXIMUM_CHARS_PER_LINE){
      var svgText = document.createElementNS('http://www.w3.org/2000/svg', 'text')
      svgText.setAttribute('x', `${x}`)
      svgText.setAttribute('y', `${y}`)
      svgText.setAttributeNS(null, 'font-family','Helvetica, Arial, sans-serif')
      svgText.setAttribute('text-anchor', `middle`)
      svgText.setAttribute('style', `font-size: 13px;font-family: Helvetica, Arial, sans-serif;`)
      var tSpanTextNode = document.createTextNode(text);
      svgText.appendChild(tSpanTextNode)
      subtextNodeSVG.appendChild(svgText);

      let text_width = getTextWidth(text, '13px Helvetica')
      let toBeReduced = (getTextWidth(text, '13px Helvetica')) * (0.70)
      var rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");

      rect.setAttribute("x", `${x-toBeReduced}`);
      rect.setAttribute("y", `${y-10}`);
      rect.setAttribute("width", text_width);
      rect.setAttribute("height", 14);
      rect.setAttribute("fill", "white");
      subtextNodeSVG.insertBefore(rect, svgText);

      y = parseInt(y) + 13
    }else{
      let wrappedWord = wordWrap(text, MAXIMUM_CHARS_PER_LINE)
      let maxWiddth = 0
      wrappedWord.forEach(wordBreak=>{
              var svgText = document.createElementNS('http://www.w3.org/2000/svg', 'text')
              svgText.setAttribute('x', `${x}`)
              svgText.setAttribute('y', `${y}`)
              svgText.setAttribute('style', `font-size: 13px; font-family: Helvetica, Arial, sans-serif;`)
              svgText.setAttribute('text-anchor', `middle`)

              var tSpanTextNode = document.createTextNode(wordBreak);
              svgText.appendChild(tSpanTextNode)
              subtextNodeSVG.appendChild(svgText);

              let text_width = getTextWidth(wordBreak, '13px Helvetica')
              if(text_width > maxWiddth) maxWiddth = text_width
              let toBeReduced = (getTextWidth(maxWiddth, '13px Helvetica')) * .70
              var rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
              rect.setAttribute("x", `${(x - toBeReduced)}`);
              rect.setAttribute("y", `${y-10}`);
              rect.setAttribute("width", ((maxWiddth)));
              rect.setAttribute("height", 14);
              rect.setAttribute("fill", "white");
              subtextNodeSVG.insertBefore(rect, svgText);

              y = parseInt(y) + 13
            })
    }
  })

  return subtextNodeSVG;
}

const wordWrap = (words, MAXIMUM_CHARS_PER_LINE) =>{
  let longNotesArray = []
  let splitText = words.split(/\s+/)
  let string = ''
//loop through text adding each word to string until length is longer than 20
  for(let i = 0; i < splitText.length ; i++){
    if(parseInt(string.length) + parseInt(splitText[i].length) < MAXIMUM_CHARS_PER_LINE){
      string += " "+ splitText[i]
    }else{
      longNotesArray.push(string)
      string = ''
      string = splitText[i]
    }
  }

  //if any remaining text left to be added to the array
  if(string.length > 0) longNotesArray.push(string)
  return longNotesArray
}

const getLineSVG = (lineNode, negativeOffset, heightOffset) =>{
  var parentLineNode = createParentLineTag()
  let copyNode = null
    for(let j = 0; j < lineNode.childNodes.length; j++){
      lineNode.childNodes[j].childNodes.forEach(node=>{
        if(node.nodeName !== 'div'){
          if(node.x1 !== undefined && node.x2 !== undefined && node.y1 !== undefined && node.y2 !== undefined){
            let x1 = node.x1.baseVal.value + negativeOffset
            let x2 = node.x2.baseVal.value + negativeOffset
            let y1 = node.y1.baseVal.value + heightOffset
            let y2 = node.y2.baseVal.value + heightOffset
            copyNode = node.cloneNode(true)
            copyNode.setAttribute("x1", x1)
            copyNode.setAttribute("x2", x2)
            copyNode.setAttribute("y1", y1)
            copyNode.setAttribute("y2", y2)
            copyNode.setAttribute("style", "stroke:rgb(0, 0, 0); stroke-width:2px; fill:none")
          }
          else{
            copyNode = node.cloneNode(true)
            copyNode.setAttribute("transform", `translate(${negativeOffset}, ${heightOffset})`)
            copyNode.setAttribute("style", "stroke:rgb(0, 0, 0); stroke-width:2px; fill:none")

          }
          parentLineNode.appendChild(copyNode)
        }
      })
    }
  return parentLineNode
}

const createParentGTag =   (x, y) =>{
  const parentGTag = document.createElementNS('http://www.w3.org/2000/svg', 'g')
  parentGTag.setAttribute("transform", `matrix(1, 0, 0, 1, ${x}, ${y})`)

  return parentGTag
}

const createParentLineTag = () =>{
  const parentGTag =  document.createElementNS('http://www.w3.org/2000/svg', 'g')
  return parentGTag
}


const createProbandArrowTag = () =>{

  const probandArrow = document.createElementNS('http://www.w3.org/2000/svg', 'g')
  probandArrow.setAttribute("transform", `matrix(1, 0, 0, 1, -22, 30)`)

  return probandArrow

}
const getTransformation = (node, negativeOffset, heightOffset) =>{
  let transform = node.style.transform
  if(transform.length > 0){
    var regExp = new RegExp(/\(([^)]+)\)/);

    let transforming = regExp.exec(transform)
    let split =transforming[1].split(',')
    let x = split[0].replace('px', '').trim()
    let y = split[1].replace('px', '').trim()

    return {
      'x': parseFloat(x) + parseFloat(negativeOffset),
      'y': parseFloat(y) + parseFloat(heightOffset)
    }
  }
}

const getTextWidth = (text, font) => {
  let canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  let context = canvas.getContext("2d");
  context.font = font;
  let metrics = context.measureText(text);
  return metrics.width;
}

const createPatientHeader = (payload) =>{

  let singlePageHeight = 755
  let singlePageWidth = 1000
  let fontSize = 13
  var xmlns = "http://www.w3.org/2000/svg";
  let XPosition = 50

  const svgHeader = document.createElementNS(xmlns, 'svg')
  svgHeader.setAttributeNS(null, 'width', singlePageWidth)
  svgHeader.setAttributeNS(null, 'height', singlePageHeight)

  if(payload.is_identified){
    let lastName = payload.lastName ? `${payload.lastName}` : ''
    let first = payload.firstName ? `${payload.firstName} ` : ''
    let fullName = first + lastName
    let patientId = payload.id ?  payload.id : ''
    let patientDOB = payload.dob  ? payload.dob : ''
    let age = payload.age ? payload.age : ''
    let nameLength = getTextWidth(fullName, '11px Helvetica')
    let idLength = getTextWidth(patientId, '11px Helvetica')

    if(patientDOB){
      let birthday = new Date(patientDOB)

      // this will disregard the timezone offsets and just display the DOB as it is
      birthday = new Date( birthday.getTime() + Math.abs(birthday.getTimezoneOffset()*60000) )
      let optionsDob = { year: 'numeric', month: 'numeric', day: 'numeric' };
      birthday = moment(birthday).format(getLocaleDateString())
      patientDOB = birthday
    }

    let nameHeader  = 'Patient Name: '
    let nameText = fullName
    //create Name portion of the header
    var patientTitle = createHeaderNodesSVG(nameHeader, XPosition, 15)
    XPosition += 95
    var patientConent = createHeaderContentSVG(nameText, XPosition, 15)
    svgHeader.append(patientTitle);
    svgHeader.append(patientConent);

    let patientNameOffset = fullName.length > 25 ? 55 : fullName.length > 15 ? 30 : 20

    XPosition +=((nameLength + patientNameOffset))
    //create div for patients id and move it left of the patients name div
    let idHeader = 'ID: '
    let idText = patientId
    var patientIdHeader = createHeaderNodesSVG(idHeader, XPosition, 15)
    XPosition +=20
    var patientIdContent = createHeaderContentSVG(idText, XPosition, 15)

    svgHeader.append(patientIdHeader);
    svgHeader.append(patientIdContent)

    let dobHeader = 'DOB: '

    let idOffset = patientId.length > 30 ? 50 : patientId.length > 25 ? 45 : patientId.length > 10 ? 35 : 25
    let seperator = (patientDOB && age ) ? ' | ' : ''
    let dobContent = patientDOB + seperator + age
    XPosition += (idLength + idOffset)
    var patientDobHeader = createHeaderNodesSVG(dobHeader, XPosition, 15)
    XPosition +=37
    var patientDobContent = createHeaderContentSVG(dobContent, XPosition, 15)

    svgHeader.appendChild(patientDobHeader)
    svgHeader.append(patientDobContent)
  }

  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = mm + '/' + dd + '/' + yyyy;
  today = new Date(today)
  today = moment(today).format(getLocaleDateString())



  let todayHeader =  'Date: '
  var todayDateHeader = createHeaderNodesSVG(todayHeader, 805, 15)
  var todayString = createHeaderContentSVG(today, 842, 15)

  svgHeader.append(todayDateHeader);
  svgHeader.append(todayString);

  const svgStringHeader = new XMLSerializer().serializeToString(svgHeader)

  return svgStringHeader

}


const createHeaderNodesSVG = (headerTitle, x, y) =>{
  var xmlns = "http://www.w3.org/2000/svg";
  let fontSize = 14;

  let titleNode = document.createElementNS(xmlns, "text");
  titleNode.setAttributeNS(null,"x", x);
  titleNode.setAttributeNS(null,"y", y);
  titleNode.setAttributeNS(null,"font-family", 'Helvetica, Arial, sans-serif');
  titleNode.setAttributeNS(null,"font-size", fontSize);
  titleNode.setAttributeNS(null,"font-weight", "bold");
  var title = document.createTextNode(headerTitle);
  titleNode.appendChild(title)

  return titleNode
}


const createHeaderContentSVG = (headerContent, x, y) => {
  let fontSize = 13
  var xmlns = "http://www.w3.org/2000/svg";

  let contentNode = document.createElementNS(xmlns, "text");
  contentNode.setAttributeNS(null,"x", x);
  contentNode.setAttributeNS(null,"y", y);
  contentNode.setAttributeNS(null,"font-size", fontSize);
  contentNode.setAttributeNS(null,"font-family", 'Helvetica, Arial, sans-serif');
 var content = document.createTextNode(headerContent);

  contentNode.appendChild(content)
  return contentNode
}


const createPatientFooter = () =>{
  let displayBlackAndWhite = Cookie.get('famgenix_pedigree_black_and_white');
  const displayBlackAndWhiteBool = displayBlackAndWhite === 'true';

  let singlePageHeight = 755
  let singlePageWidth = 1000
  let xDisease = 40
  let yDisease = 640
  let xOffset = displayBlackAndWhiteBool ? 13 : 9;
  let yOffset = displayBlackAndWhiteBool ? 10 : 8;
  let fontSize = 10
  let diseaseCounter = 0
  let maxLength = 0
  let yNotesHeader = 640
  var xmlns = "http://www.w3.org/2000/svg";


  const EYE_IMAGE_SLASHED = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABCUlEQVR4nMWSwVGDUBCGP21AOpAOjBVIByYVSC7/GSuQVBDOe4ESKIF0EDuIHSQd5MCPMHBwogd3hpnH291v/9198FeLiCQi8t/m3wNroI6INiKSWwF3VlEAe+ALKIAVkAEvjvsEOqCSdFoADFkBLfDoq52TMOzD562kZtrCYCdXPvg/9VcYvPF9bcUjICIyV0slZa7+BtTAq32dWwHYO+dbQQk8AV1E5JJKV7zY/2B154nicg4YAksASa2ThqprIJkDpkMs6DcBs0FFROOWBttZ5QhwYE7fN4xbOEs62ldZ5bOk4wJgSEo/+Yx+LgAbSe1s1e+SqgXgJ/Nrbei3s70ZMAHlVvPPdgVK7V4Cn84qGgAAAABJRU5ErkJggg==";

  let eye_images = document.getElementsByClassName('legend-dom-column-one')
  while(eye_images.length > 0){
    if(eye_images[0].firstChild.currentSrc == EYE_IMAGE_SLASHED){
      eye_images[0].parentNode.removeChild(eye_images[0].nextSibling)
    }
    eye_images[0].parentNode.removeChild(eye_images[0]);
  }
  let legendColor =  document.getElementsByClassName('legend-dom-inner-row')
  let notes = document.getElementById(constants.PEDIGREE_NOTES_ELEMENT);
  let notes_container = document.getElementById(constants.PEDIGREE_NOTES_CONTAINER_ELEMENT);

  //Create SVG tag for the footer
  const svgFooter = document.createElementNS(xmlns, 'svg')
  svgFooter.setAttributeNS(null, 'width', singlePageWidth)
  svgFooter.setAttributeNS(null, 'height', singlePageHeight)


  for(let i=0; i<legendColor.length; i++){
    if(diseaseCounter >= 6 && (diseaseCounter % 6 == 0)){
      xDisease += displayBlackAndWhiteBool ? 9 * maxLength : 6.5 * maxLength
      yDisease = 640
      maxLength = 0
    }

    let diseaseName = legendColor[i].childNodes[1].innerText
    if(diseaseName.length >= 40) diseaseName = diseaseName.substring(0,40);

    let splitColors = displayBlackAndWhiteBool ? `url(#${legendColor[i].childNodes[0].firstChild.dataset.imageid})` : legendColor[i].childNodes[0].firstChild.style.backgroundColor
    var rect = document.createElementNS( xmlns,'rect');
    rect.setAttributeNS( null, 'x', xDisease);
    rect.setAttributeNS( null, 'y', yDisease);
    rect.setAttributeNS( null, 'width', displayBlackAndWhiteBool ? '12' : '8');
    rect.setAttributeNS( null, 'height', displayBlackAndWhiteBool ? '12' : '8');
    rect.setAttributeNS( null, 'rx', "2");
    rect.setAttributeNS( null, 'ry', "2");
    rect.setAttributeNS( null, 'fill', splitColors);


    var diseaseDisplay = document.createElementNS(xmlns, "text");
    diseaseDisplay.setAttributeNS(null,"x", xDisease + xOffset);
    diseaseDisplay.setAttributeNS(null,"y", yDisease + yOffset);
    diseaseDisplay.setAttributeNS(null,"font-size", fontSize);
    diseaseDisplay.setAttributeNS(null, "font-family", "Helvetica, Arial, sans-serif");
    var disease = document.createTextNode(diseaseName);

    diseaseDisplay.appendChild(disease)
    svgFooter.appendChild(rect)
    svgFooter.appendChild(diseaseDisplay)
    maxLength =  (diseaseName.length >= 40) ? 40 : (diseaseName.length > maxLength) ? diseaseName.length : maxLength

    yDisease += 14
    diseaseCounter +=1

  }


  //Creating pdf footer

  if(notes && notes.value){
    let MAXIMUM_CHARS_PER_LINE = 45
    let xNotes = 750
    let yNotesContent = 655

    //initial number of rows that can fit on one page based on 45 chars per line
    const notesInitialVerticalRows = 8
    const initialNotesLines = (notes.value.length / 45)

    //check amt of space disease rows are taking up
    const diseaseRowWidth = 150
    const maxDiseasePerColumn = 6
    const diseaseLength = diseaseCounter
    const diseaseRows = diseaseLength / maxDiseasePerColumn
    const diseaseWidth = diseaseRows * diseaseRowWidth


    //if intiial notes will take up more rows than can fit on one page check whether to shift left or up
    //depending on disease width
    if(initialNotesLines > 8){
      if(diseaseWidth <= 650){
        MAXIMUM_CHARS_PER_LINE = (notes.value.length / 7)
        xNotes = diseaseWidth + 175
      }else{
        yNotesContent -= ((initialNotesLines - notesInitialVerticalRows) * 20)
      }
    }
    //If disease width will run into notes, if so shift notes above diseases
    if(diseaseWidth > xNotes){
      yNotesHeader = 580
      yNotesContent= yNotesHeader + 15
      xNotes = 40
      MAXIMUM_CHARS_PER_LINE = 175
    }

    let words = wordWrap(notes.value, MAXIMUM_CHARS_PER_LINE )

    yNotesHeader = yNotesContent - 15
    var pedgireeHeader = createHeaderNodesSVG('Pedigree Notes:', xNotes, yNotesHeader )

    words.forEach(word=>{
      if(word){
        var svgText = document.createElementNS('http://www.w3.org/2000/svg', 'text')
        svgText.setAttribute('x', `${xNotes}`)
        svgText.setAttribute('y', `${yNotesContent}`)
        svgText.setAttribute('style', `font-size: ${fontSize}; font-family: Helvetica, Arial, sans-serif;`)

        var tSpanTextNode = document.createTextNode(word);
        svgText.appendChild(tSpanTextNode)

        svgFooter.appendChild(svgText)
        yNotesContent = parseInt(yNotesContent) + 13
      }
    })

    svgFooter.appendChild(pedgireeHeader)
  }

  let footerHeight = (notes || diseaseCounter > 0 ) ? singlePageHeight - yNotesHeader : 0
  let legend_dom = document.getElementById(constants.LEGEND_DOM_CONTAINER_ELEMENT)

  if (notes) notes.remove()
  if (notes_container) notes_container.remove()
  if (legend_dom) legend_dom.remove()

  const svgStringFooter = new XMLSerializer().serializeToString(svgFooter)

  return {
    'footerSVG': svgStringFooter,
    'footerHeight' : parseFloat(footerHeight)
  }
}


const createImageString = (pedigree, width, height, patientInfo, negativeOffset, heightOffset) => {
  let adjustedHeight = height + 125
  let adjustedWidth = width + 200
  const minWidth = 1100
  const minHeight = 750

  let imageWidth = adjustedWidth > minWidth ? adjustedWidth : minWidth
  negativeOffset = adjustedWidth > minWidth ? negativeOffset - 100 : adjustedWidth < 800 ? negativeOffset - 300 : negativeOffset - 50
  let imageHeight = adjustedHeight > minHeight ? adjustedHeight : minHeight
  let pedigreeCopy = CreateSvgString(pedigree, imageWidth, imageHeight + 15, negativeOffset, heightOffset - 115)
  let header = createImageHeader(patientInfo, imageHeight, imageWidth)
  let footer = createImageFooter(imageHeight, imageWidth)
  pedigreeCopy.setAttributeNS(null, "height", footer["height"])
  pedigreeCopy.appendChild(footer["svg"])
  pedigreeCopy.append(header)

  let pedigireeString = new XMLSerializer().serializeToString(pedigreeCopy)

  return pedigireeString
}

const getLocaleDateString = () => {
  var formats = { "ar-SA": "DD/MM/YY", "bg-BG": "DD.MM.YYYY", "ca-ES": "DD/MM/YYYY", "zh-TW": "YYYY/MM/DD", "cs-CZ": "DD.MM.YYYY", "da-DK": "DD-MM-YYYY", "de-DE": "DD.MM.YYYY", "el-GR": "DD/MM/YYYY", "en": "MM/DD/YYYY", "en-US": "MM/DD/YYYY", "fi-FI": "DD.MM.YYYY", "fr-FR": "DD/MM/YYYY", "he-IL": "DD/MM/YYYY", "hu-HU": "YYYY. MM. DD.", "is-IS": "DD.MM.YYYY", "it-IT": "DD/MM/YYYY", "ja-JP": "YYYY/MM/DD", "ko-KR": "YYYY-MM-DD", "nl-NL": "DD-MM-YYYY", "nb-NO": "DD.MM.YYYY", "pl-PL": "YYYY-MM-DD", "pt-BR": "DD/MM/YYYY", "ro": "DD.MM.YYYY", "ro-RO": "DD.MM.YYYY", "ru-RU": "DD.MM.YYYY", "hr-HR": "DD.MM.YYYY", "sk-SK": "DD. MM. YYYY", "sq-AL": "YYYY-MM-DD", "sv-SE": "YYYY-MM-DD", "th-TH": "DD/MM/YYYY", "tr-TR": "DD.MM.YYYY", "ur-PK": "DD/MM/YYYY", "id-ID": "DD/MM/YYYY", "uk-UA": "DD.MM.YYYY", "be-BY": "DD.MM.YYYY", "sl-SI": "DD.MM.YYYY", "et-EE": "DD.MM.YYYY", "lv-LV": "YYYY.MM.DD.", "lt-LT": "YYYY.MM.DD", "fa-IR": "MM/DD/YYYY", "vi-VN": "DD/MM/YYYY", "hy-AM": "DD.MM.YYYY", "az-Latn-AZ": "DD.MM.YYYY", "eu-ES": "YYYY/MM/DD", "mk-MK": "DD.MM.YYYY", "af-ZA": "YYYY/MM/DD", "ka-GE": "DD.MM.YYYY", "fo-FO": "DD-MM-YYYY", "hi-IN": "DD-MM-YYYY", "ms-MY": "DD/MM/YYYY", "kk-KZ": "DD.MM.YYYY", "ky-KG": "DD.MM.YY", "sw-KE": "MM/DD/YYYY", "uz-Latn-UZ": "DD/MM YYYY", "tt-RU": "DD.MM.YYYY", "pa-IN": "DD-MM-YY", "gu-IN": "DD-MM-YY", "ta-IN": "DD-MM-YYYY", "te-IN": "DD-MM-YY", "kn-IN": "DD-MM-YY", "mr-IN": "DD-MM-YYYY", "sa-IN": "DD-MM-YYYY", "mn-MN": "YY.MM.DD", "gl-ES": "DD/MM/YY", "kok-IN": "DD-MM-YYYY", "syr-SY": "DD/MM/YYYY", "dv-MV": "DD/MM/YY", "ar-IQ": "DD/MM/YYYY", "zh-CN": "YYYY/MM/DD", "de-CH": "DD.MM.YYYY", "en-GB": "DD/MM/YYYY", "es-MX": "DD/MM/YYYY", "fr-BE": "DD/MM/YYYY", "it-CH": "DD.MM.YYYY", "nl-BE": "DD/MM/YYYY", "nn-NO": "DD.MM.YYYY", "pt-PT": "DD-MM-YYYY", "sr-Latn-CS": "DD.MM.YYYY", "sv-FI": "DD.MM.YYYY", "az-Cyrl-AZ": "DD.MM.YYYY", "ms-BN": "DD/MM/YYYY", "uz-Cyrl-UZ": "DD.MM.YYYY", "ar-EG": "DD/MM/YYYY", "zh-HK": "DD/MM/YYYY", "de-AT": "DD.MM.YYYY", "en-AU": "DD/MM/YYYY", "es-ES": "DD/MM/YYYY", "fr-CA": "YYYY-MM-DD", "sr-Cyrl-CS": "DD.MM.YYYY", "ar-LY": "DD/MM/YYYY", "zh-SG": "DD/MM/YYYY", "de-LU": "DD.MM.YYYY", "en-CA": "DD/MM/YYYY", "es-GT": "DD/MM/YYYY", "fr-CH": "DD.MM.YYYY", "ar-DZ": "DD-MM-YYYY", "zh-MO": "DD/MM/YYYY", "de-LI": "DD.MM.YYYY", "en-NZ": "DD/MM/YYYY", "es-CR": "DD/MM/YYYY", "fr-LU": "DD/MM/YYYY", "ar-MA": "DD-MM-YYYY", "en-IE": "DD/MM/YYYY", "es-PA": "MM/DD/YYYY", "fr-MC": "DD/MM/YYYY", "ar-TN": "DD-MM-YYYY", "en-ZA": "YYYY/MM/DD", "es-DO": "DD/MM/YYYY", "ar-OM": "DD/MM/YYYY", "en-JM": "DD/MM/YYYY", "es-VE": "DD/MM/YYYY", "ar-YE": "DD/MM/YYYY", "en-029": "MM/DD/YYYY", "es-CO": "DD/MM/YYYY", "ar-SY": "DD/MM/YYYY", "en-BZ": "DD/MM/YYYY", "es-PE": "DD/MM/YYYY", "ar-JO": "DD/MM/YYYY", "en-TT": "DD/MM/YYYY", "es-AR": "DD/MM/YYYY", "ar-LB": "DD/MM/YYYY", "en-ZW": "MM/DD/YYYY", "es-EC": "DD/MM/YYYY", "ar-KW": "DD/MM/YYYY", "en-PH": "MM/DD/YYYY", "es-CL": "DD-MM-YYYY", "ar-AE": "DD/MM/YYYY", "es-UY": "DD/MM/YYYY", "ar-BH": "DD/MM/YYYY", "es-PY": "DD/MM/YYYY", "ar-QA": "DD/MM/YYYY", "es-BO": "DD/MM/YYYY", "es-SV": "DD/MM/YYYY", "es-HN": "DD/MM/YYYY", "es-NI": "DD/MM/YYYY", "es-PR": "DD/MM/YYYY", "am-ET": "DD/MM/YYYY", "tzm-Latn-DZ": "DD-MM-YYYY", "iu-Latn-CA": "DD/MM/YYYY", "sma-NO": "DD.MM.YYYY", "mn-Mong-CN": "YYYY/MM/DD", "gd-GB": "DD/MM/YYYY", "en-MY": "DD/MM/YYYY", "prs-AF": "DD/MM/YY", "bn-BD": "DD-MM-YY", "wo-SN": "DD/MM/YYYY", "rw-RW": "MM/DD/YYYY", "qut-GT": "DD/MM/YYYY", "sah-RU": "MM.DD.YYYY", "gsw-FR": "DD/MM/YYYY", "co-FR": "DD/MM/YYYY", "oc-FR": "DD/MM/YYYY", "mi-NZ": "DD/MM/YYYY", "ga-IE": "DD/MM/YYYY", "se-SE": "YYYY-MM-DD", "br-FR": "DD/MM/YYYY", "smn-FI": "DD.MM.YYYY", "moh-CA": "MM/DD/YYYY", "arn-CL": "DD-MM-YYYY", "ii-CN": "YYYY/mM/DD", "dsb-DE": "DD. MM. YYYY", "ig-NG": "DD/MM/YYYY", "kl-GL": "DD-MM-YYYY", "lb-LU": "DD/MM/YYYY", "ba-RU": "DD.MM.YY", "nso-ZA": "YYYY/MM/DD", "quz-BO": "DD/MM/YYYY", "yo-NG": "DD/MM/YYYY", "ha-Latn-NG": "DD/MM/YYYY", "fil-PH": "MM/DD/YYYY", "ps-AF": "DD/MM/YY", "fy-NL": "DD-MM-YYYY", "ne-NP": "MM/DD/YYYY", "se-NO": "DD.MM.YYYY", "iu-Cans-CA": "DD/MM/YYYY", "sr-Latn-RS": "DD.MM.YYYY", "si-LK": "YYYY-MM-DD", "sr-Cyrl-RS": "DD.MM.YYYY", "lo-LA": "DD/MM/YYYY", "km-KH": "YYYY-MM-DD", "cy-GB": "DD/MM/YYYY", "bo-CN": "YYYY/MM/DD", "sms-FI": "DD.MM.YYYY", "as-IN": "DD-MM-YYYY", "ml-IN": "DD-MM-YY", "en-IN": "DD-MM-YYYY", "or-IN": "DD-MM-YY", "bn-IN": "DD-MM-YY", "tk-TM": "DD.MM.YY", "bs-Latn-BA": "DD.MM.YYYY", "mt-MT": "DD/MM/YYYY", "sr-Cyrl-ME": "DD.MM.YYYY", "se-FI": "DD.MM.YYYY", "zu-ZA": "YYYY/MM/DD", "xh-ZA": "YYYY/MM/DD", "tn-ZA": "YYYY/MM/DD", "hsb-DE": "DD. MM. YYYY", "bs-Cyrl-BA": "DD.MM.YYYY", "tg-Cyrl-TJ": "DD.MM.YY", "sr-Latn-BA": "DD.MM.YYYY", "smj-NO": "DD.MM.YYYY", "rm-CH": "DD/MM/YYYY", "smj-SE": "YYYY-MM-DD", "quz-EC": "DD/MM/YYYY", "quz-PE": "DD/MM/YYYY", "hr-BA": "DD.MM.YYYY.", "sr-Latn-ME": "DD.MM.YYYY", "sma-SE": "YYYY-MM-DD", "en-SG": "DD/MM/YYYY", "ug-CN": "YYYY-MM-DD", "sr-Cyrl-BA": "DD.MM.YYYY", "es-US": "MM/DD/YYYY" }
  return formats[navigator.language] ||  'DD/MM/YYYY';
}

const createImageHeader = (payload, height, width) => {
  let singlePageHeight = height
  let singlePageWidth = width
  let y = 20
  let XPosition = 50
  let xDate = .7 * singlePageWidth
  var xmlns = "http://www.w3.org/2000/svg";


  const svgHeader = document.createElementNS(xmlns, 'svg')
  svgHeader.setAttributeNS(null, 'width', singlePageWidth)
  svgHeader.setAttributeNS(null, 'height', singlePageHeight)

  let lastName = payload.lastName ? `${payload.lastName} ` : ''
  let first = payload.firstName ? `${payload.firstName} ` : ''
  let fullName = first + lastName
  let patientId = payload.id ?  payload.id : ''
  let patientDOB = payload.dob  ? payload.dob : ''
  let age = payload.age ? payload.age : ''

  let nameLength = getTextWidth(fullName, '11px Helvetica')
  let idLength = getTextWidth(patientId, '11px Helvetica')

  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = mm + '/' + dd + '/' + yyyy;
  today = new Date(today)
  today = moment(today).format(getLocaleDateString())

  if (payload.is_identified){
    if(patientDOB){
      let birthday = new Date(patientDOB)

      // this will disregard the timezone offsets and just display the DOB as it is
      birthday = new Date(birthday.getTime() + Math.abs(birthday.getTimezoneOffset() * 60000))
      let optionsDob = { year: 'numeric', month: 'numeric', day: 'numeric' };
      birthday = moment(birthday).format(getLocaleDateString())
      patientDOB = birthday
    }

    let nameHeader  = 'Patient Name: '
    let nameText = fullName
    //create Name portion of the header
    var patientTitle = createHeaderNodesSVG(nameHeader, XPosition, y)
    XPosition += 95
    var patientConent = createHeaderContentSVG(nameText, XPosition, y)

    svgHeader.append(patientTitle);
    svgHeader.append(patientConent);

    //create div for patients id and move it left of the patients name div
    let patientNameOffset = fullName.length > 25 ? 55 : fullName.length > 15 ? 30 : 20
    XPosition +=((nameLength + patientNameOffset))

    let idHeader = 'ID: '
    let idText = patientId
    var patientIdHeader = createHeaderNodesSVG(idHeader, XPosition, y)
    XPosition +=20
    var patientIdContent = createHeaderContentSVG(idText, XPosition, y)


    svgHeader.append(patientIdHeader);
    svgHeader.append(patientIdContent)


    let dobHeader = 'DOB: '

    let idOffset = patientId.length > 30 ? 50 : patientId.length > 25 ? 45 : patientId.length > 10 ? 35 : 25
    XPosition += (idLength + idOffset)

    let seperator = (patientDOB && age ) ? ' | ' : ''
    let dobContent = patientDOB + seperator + age
    var patientDobHeader = createHeaderNodesSVG(dobHeader, XPosition, y)
    XPosition +=37
    var patientDobContent = createHeaderContentSVG(dobContent,  XPosition, y)

    svgHeader.appendChild(patientDobHeader)
    svgHeader.append(patientDobContent)
  }

  let todayHeader =  'Date: '
  var todayDateHeader = createHeaderNodesSVG(todayHeader, xDate, y)
  var todayString = createHeaderContentSVG(today, xDate + 35 , y)

  svgHeader.append(todayDateHeader);
  svgHeader.append(todayString);

  return svgHeader
}


const createImageFooter = (imageHeight, imageWidth) =>{
  let displayBlackAndWhite = Cookie.get('famgenix_pedigree_black_and_white');
  const displayBlackAndWhiteBool = displayBlackAndWhite === 'true';

  let singlePageHeight = imageHeight
  let singlePageWidth = imageWidth
  const padding = 15
  let xDisease = 40
  let yDisease = imageHeight + padding
  let maxHeight = yDisease
  let xOffset = displayBlackAndWhiteBool ? 13 : 9;
  let yOffset = displayBlackAndWhiteBool? 10 : 8;
  let fontSize = 15
  let diseaseCounter = 0
  let maxLength = 0
  var xmlns = "http://www.w3.org/2000/svg";


  const EYE_IMAGE_SLASHED = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABCUlEQVR4nMWSwVGDUBCGP21AOpAOjBVIByYVSC7/GSuQVBDOe4ESKIF0EDuIHSQd5MCPMHBwogd3hpnH291v/9198FeLiCQi8t/m3wNroI6INiKSWwF3VlEAe+ALKIAVkAEvjvsEOqCSdFoADFkBLfDoq52TMOzD562kZtrCYCdXPvg/9VcYvPF9bcUjICIyV0slZa7+BtTAq32dWwHYO+dbQQk8AV1E5JJKV7zY/2B154nicg4YAksASa2ThqprIJkDpkMs6DcBs0FFROOWBttZ5QhwYE7fN4xbOEs62ldZ5bOk4wJgSEo/+Yx+LgAbSe1s1e+SqgXgJ/Nrbei3s70ZMAHlVvPPdgVK7V4Cn84qGgAAAABJRU5ErkJggg==";

  let eye_images = document.getElementsByClassName('legend-dom-column-one')
  while(eye_images.length > 0){
    if(eye_images[0].firstChild.currentSrc == EYE_IMAGE_SLASHED){
      eye_images[0].parentNode.removeChild(eye_images[0].nextSibling)
    }
    eye_images[0].parentNode.removeChild(eye_images[0]);
  }
  let legendColor =  document.getElementsByClassName('legend-dom-inner-row')
  let notes = document.getElementById(constants.PEDIGREE_NOTES_ELEMENT);
  let notes_container = document.getElementById(constants.PEDIGREE_NOTES_CONTAINER_ELEMENT);

  //Create SVG tag for the footer
  const svgFooter = document.createElementNS(xmlns, 'g')
  for(let i=0; i<legendColor.length; i++){
    if(diseaseCounter >= 7 && (diseaseCounter % 7 == 0)){
      xDisease += displayBlackAndWhiteBool ? 10 * maxLength : 8 * maxLength
      yDisease = imageHeight + padding
      maxLength = 0
    }

    let diseaseName = legendColor[i].childNodes[1].innerText
    if(diseaseName.length >= 40) diseaseName = diseaseName.substring(0,40);


    let splitColors = displayBlackAndWhiteBool ? `url(#${legendColor[i].childNodes[0].firstChild.dataset.imageid})` : legendColor[i].childNodes[0].firstChild.style.backgroundColor
    var rect = document.createElementNS( xmlns,'rect');
    rect.setAttributeNS( null, 'x', xDisease);
    rect.setAttributeNS( null, 'y', yDisease);
    rect.setAttributeNS( null, 'width', displayBlackAndWhiteBool ? '12' : '8');
    rect.setAttributeNS( null, 'height', displayBlackAndWhiteBool ? '12' : '8');
    rect.setAttributeNS( null, 'rx', "2");
    rect.setAttributeNS( null, 'ry', "2");
    rect.setAttributeNS( null, 'fill', splitColors);


    var diseaseDisplay = document.createElementNS(xmlns, "text");
    diseaseDisplay.setAttributeNS(null,"x", xDisease + xOffset);
    diseaseDisplay.setAttributeNS(null,"y", yDisease + yOffset);
    diseaseDisplay.setAttributeNS(null,"font-size", fontSize);
    var disease = document.createTextNode(diseaseName);

    diseaseDisplay.appendChild(disease)
    svgFooter.appendChild(rect)
    svgFooter.appendChild(diseaseDisplay)
    maxLength =  (diseaseName.length >= 40) ? 40 : (diseaseName.length > maxLength) ? diseaseName.length : maxLength

    yDisease += 14
    maxHeight = yDisease > maxHeight ? yDisease : maxHeight
    diseaseCounter +=1

  }

  let yNotesHeader =  imageHeight + padding
  let yNotesContent =  yNotesHeader + 15
  let xNotes = .7 * imageWidth
  let MAXIMUM_CHARS_PER_LINE = 45
  if(notes && notes.value){
    var pedigreeFooter = createHeaderNodesSVG('Pedigree Notes:', xNotes, yNotesHeader )

    let words = wordWrap(notes.value, MAXIMUM_CHARS_PER_LINE)
    words.forEach(word=>{
      if(word){
        var svgText = document.createElementNS('http://www.w3.org/2000/svg', 'text')
        svgText.setAttribute('x', `${xNotes}`)
        svgText.setAttribute('y', `${yNotesContent}`)

        svgText.setAttribute('style', `font-size: ${fontSize}; font-family: Helvetica, Arial, sans-serif;`)
        var tSpanTextNode = document.createTextNode(word);
        svgText.appendChild(tSpanTextNode)
        svgFooter.appendChild(svgText)
        yNotesContent = parseInt(yNotesContent) + 13
        maxHeight = yNotesContent > maxHeight ? yNotesContent : maxHeight
      }
    })
    svgFooter.appendChild(pedigreeFooter)

  }

  return  {"svg": svgFooter, "height": maxHeight}
}


 const createFamily = (name, diseases, genes, profiles, pedigreeNotes, svgContainer) =>{
  const singlePageHeight = 675
  let xHeader = 20
  let yData = 15
  let xContent = 40

  const personalHeader = createHeaderNodesSVG('Personal History', xHeader, yData)
  svgContainer.appendChild(personalHeader)
  yData = increaseValue(yData, 20)
  
  let nameLength = getTextWidth(name, '11px Helvetica')
  let probandNameContainer = createTextContainer(xContent, yData);
  probandNameContainer.setAttribute('font-weight', 'bold')
  var tSpanTextNode = document.createTextNode(name);
  probandNameContainer.appendChild(tSpanTextNode);
  svgContainer.appendChild(probandNameContainer)

  // const probandContainer = createTextContainer(xContent + (nameLength + 1.2), yData);
  let probandString = diseases.length > 0 || genes.length > 0 ? '- ' : ''
  probandString += getDiseaseString(diseases)
  probandString += getGeneString(genes)
  yData = createPersonText(probandString, 100, svgContainer, xContent, yData, nameLength)

  yData = increaseValue(yData, 40)


  const familyHeader = createHeaderNodesSVG('Family History', xHeader, yData)
  svgContainer.appendChild(familyHeader)
  yData = increaseValue(yData, 20)

  profiles.forEach(person=>{
    let {relationship_to_proband, diseases, genetic_testing, is_dead, age_string } = person
    let finalString = diseases.length > 0 || genetic_testing.length > 0 ? '- ': ''
    //Create age string for each member
    let age = is_dead ?  `d. ${age_string} ` : age_string ? `${age_string}` : ''
    let comma = is_dead || age ? ', ': ' '
    let full_age = relationship_to_proband + comma + age
  
    //Create text for family members name
    let nameLength = getTextWidth(full_age, '11px Helvetica')
    let  familyContainer = createTextContainer(xContent, yData);
    familyContainer.setAttribute('font-weight', 'bold')

    var tSpanTextNode = document.createTextNode(full_age);
    familyContainer.appendChild(tSpanTextNode);
    svgContainer.appendChild(familyContainer)

    //create text for family members diseases and genes 
    finalString += getDiseaseString(diseases)
    finalString += getGeneString(genetic_testing)
    yData = createPersonText(finalString, 100, svgContainer, xContent, yData, nameLength)
    yData = increaseValue(yData, 20)
  })

  yData = increaseValue(yData, 40)

  if(pedigreeNotes !== null) {
    if(yData + 30 >= singlePageHeight) yData += 50
    const notesHeader = createHeaderNodesSVG('Pedigree Notes', xHeader, yData)
    yData = increaseValue(yData, 20)
    const containerNotes = createTextContainer(xContent, yData);
    containerNotes.appendChild(document.createTextNode(pedigreeNotes));
    svgContainer.appendChild(notesHeader)
    svgContainer.appendChild(containerNotes)
  }
  return [svgContainer,  yData +=20]

 }

 const createTextContainer = (x, y) =>{
    var textHeader = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    textHeader.setAttribute('font-family', 'Helvetica, Arial, sans-serif')
    textHeader.setAttribute('x', `${x}`)
    textHeader.setAttribute('y', `${y}`)
  return textHeader
 }


  const getGeneString = (genes) =>{
    let geneText = ''
    let hasNegativeGene = false
    let negativeGeneString = 'Negative Genetic Testing;'
    let hasPositiveGene = false
    genes.forEach((gene, index)=>{
        if(gene.result === 'n'){
          hasNegativeGene = true 
          return
        } 
        hasPositiveGene = true
        let geneName = gene.gene
        let geneResult = geneMap[gene.result] ? ` ${geneMap[gene.result]}; `: gene.result ?  ` ${gene.result}; ` : '' 
        let geneString =  geneName + geneResult
        geneText += geneString
    })
    if(!hasPositiveGene && hasNegativeGene) geneText += `${negativeGeneString}`
   return geneText
  }

 const getDiseaseString = (diseases) =>{
  let finalString = ''
    diseases.forEach((disease, index) => {
      console.log(disease)
      let diseaseText = disease.disease_name + (disease.age_diagnosed_string ? `, ${disease.age_diagnosed_string}` : disease.age_diagnosed ? `, ${disease.age_diagnosed}` : '');
      finalString += diseaseText
     
      let skip_logic = getSkipString(disease)
      if(skip_logic) finalString += (' '+ skip_logic) 

      let finalDisease = index !== disease.length - 1 ? '; ': ''
      finalString += finalDisease
    });
    return finalString
 }

 const getSkipString = (disease) =>{
  let skipString = ''
  skipString = skipLogicCheck(disease)
  if (skipString && skipString.charAt(skipString.length - 1) === ',') {
    skipString = skipString.slice(0, -1);
  }
  return skipString
}
 const increaseValue = (variable, offSet) =>{
    return variable += offSet
 }

 const createPersonText = (personString, maxChar, svgContent, startX, startY, nameLength) => {
  if (personString.length > maxChar){
    let splitString = wordWrap(personString, maxChar)
    
    splitString.forEach((word, index) => {
      let personContainer = null

      if(index === 0) personContainer = createTextContainer(startX + (nameLength * 1.2), startY);
      else personContainer = createTextContainer(startX, startY);
      
      var tSpanTextNode = document.createTextNode(word);
      personContainer.appendChild(tSpanTextNode)
      svgContent.appendChild(personContainer)
      if(index !== splitString.length - 1) startY = increaseValue(startY, 20)
    }
  )}else{
    let personContainer = createTextContainer(startX + (nameLength * 1.2), startY);
    var tSpanTextNode = document.createTextNode(personString);
    personContainer.appendChild(tSpanTextNode)
    svgContent.appendChild(personContainer)

  }
  return startY
 }

export default{
    CreateSvgString,
    createPatientHeader,
    createPatientFooter,
    createSVGPdf,
    createImageString,
    createImageHeader,
    createImageFooter,
    getTextWidth,
    createSvgFamilyHistory,
    increaseValue,
    getDiseaseString,
    createPersonText,
    getSkipString
}
